import React from "react";

function AdminBookings() {
  return <div>Admin Bookings Page</div>;
}

export default AdminBookings;
